module.exports = __webpack_public_path__ + "img/Lao PDR.566c1822.gif";